import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React from 'react';
import classnames from 'classnames';
import '../../../reset/HtmlA/HtmlA.js';
import { HtmlButton } from '../../../reset/HtmlButton/HtmlButton.js';
import '../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../reset/HtmlH/HtmlH.js';
import '../../../reset/HtmlInput/HtmlInput.js';
import '../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../reset/HtmlLi/HtmlLi.js';
import '../../../reset/HtmlNav/HtmlNav.js';
import '../../../reset/HtmlOl/HtmlOl.js';
import '../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../reset/HtmlUl/HtmlUl.js';
import '../../../reset/HtmlTable/HtmlTable.js';
import '../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../reset/HtmlTable/HtmlTableCell.js';
import { SuomifiThemeConsumer } from '../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../theme/SuomifiTheme/SuomifiTheme.js';
import '../../theme/SpacingProvider/SpacingProvider.js';
import { baseStyles } from './LanguageMenuItem.baseStyles.js';
import { styled } from 'styled-components';
import { LanguageMenuConsumer } from '../LanguageMenuPopover/LanguageMenuPopover.js';

var baseClassName = 'fi-language-menu-item';
var hasKeyboardFocusClassName = "".concat(baseClassName, "--isHighlighted");
var selectedClassName = "".concat(baseClassName, "--selected");
var BaseLanguageMenuItem = function BaseLanguageMenuItem(props) {
  var _a;
  var className = props.className,
    children = props.children,
    selected = props.selected,
    onSelect = props.onSelect,
    consumer = props.consumer,
    _b = props.itemIndex,
    itemIndex = _b === void 0 ? -1 : _b;
    props.theme;
    var passProps = __rest(props, ["className", "children", "selected", "onSelect", "consumer", "itemIndex", "theme"]);
  var hasKeyboardFocus = consumer.activeDescendantIndex === itemIndex;
  var listElementRef = React.useRef(null);
  React.useLayoutEffect(function () {
    var _a;
    if (hasKeyboardFocus) {
      (_a = listElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, [consumer.activeDescendantIndex]);
  return /*#__PURE__*/React.createElement(HtmlButton, __assign({
    forwardedRef: listElementRef,
    className: classnames(baseClassName, className, (_a = {}, _a[hasKeyboardFocusClassName] = hasKeyboardFocus, _a[selectedClassName] = selected, _a)),
    onClick: function onClick() {
      onSelect();
      consumer.onItemClick(itemIndex);
    },
    onMouseOver: function onMouseOver() {
      consumer.onItemMouseOver(itemIndex);
    },
    onKeyDown: function onKeyDown(event) {
      var _a;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        (_a = listElementRef.current) === null || _a === void 0 ? void 0 : _a.click();
      }
    },
    tabIndex: hasKeyboardFocus ? 0 : -1,
    id: "".concat(consumer.parentId, "-list-item-").concat(itemIndex),
    role: "menuitem",
    "aria-current": selected
  }, passProps), children);
};
var StyledLanguageMenuItem = styled(BaseLanguageMenuItem).withConfig({
  componentId: "sc-1fjt1lw-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return baseStyles(theme);
});
var LanguageMenuItem = function LanguageMenuItem(props) {
  return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
    var suomifiTheme = _a.suomifiTheme;
    return /*#__PURE__*/React.createElement(LanguageMenuConsumer, null, function (consumer) {
      return /*#__PURE__*/React.createElement(StyledLanguageMenuItem, __assign({
        theme: suomifiTheme,
        consumer: consumer
      }, props));
    });
  });
};
LanguageMenuItem.displayName = 'LanguageMenuItem';
var templateObject_1;

export { LanguageMenuItem };
//# sourceMappingURL=LanguageMenuItem.js.map
